import Button from '@payaca/components/button/Button';

import UntitledIcon from '@payaca/untitled-icons';

type Props = {
  downloadUrl?: string;
};
const DownloadTemplateButton = ({ downloadUrl }: Props) => {
  return (
    <div className="download-button-wrapper">
      <a href={downloadUrl} target="_blank" rel="noreferrer" download>
        <Button isDisabled={!downloadUrl}>
          <div className="icon-wrapper">
            <UntitledIcon name="download-01.3" />
          </div>
          <span>Download template</span>
        </Button>
      </a>
    </div>
  );
};

export default DownloadTemplateButton;
